import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NoticePara, NoticeBorder, SubmitBold } from '../styles';
import { NoticeContainer, NoticeContent } from '../../../../MakeAContribution/Components/ContributionConfirmation/styles';
class Notice extends Component {
  render() {
    return (
      <NoticeBorder>
        <NoticeContainer
          message={(
            <NoticeContent >
              { this.props.message && this.props.message[0] && this.props.message[0].field_notice_content ? <div dangerouslySetInnerHTML={{__html: this.props.message[0].field_notice_content}}></div>
              :
              <>
              <NoticePara>
                Please note, once the assets are received by Vanguard Charitable, contributions of securities take approximately one business week to settle and be reflected in the balance of your philanthropic account. You can track the contribution progress by clicking Contributions > Contribution Activity and choosing the date of your contribution.
              </NoticePara>
              </>
              }
              </NoticeContent>
          )}> </NoticeContainer>
      </NoticeBorder>
    );
  }
}

Notice.propTypes = {
  message: PropTypes.array
}

export default Notice;
